import { Link } from '@/components/atoms/Link';
import { ArrowRightEndOnRectangleIcon } from '@heroicons/react/24/outline';
import {
  ExclamationCircleIcon,
  EyeIcon,
  PencilSquareIcon,
  RocketLaunchIcon,
} from '@heroicons/react/24/solid';
import clsx from 'clsx';
import { useAuth } from '../../../hooks/useAuth';
import Button, { ButtonVariants } from '../../atoms/Button/Button';

interface DealerEditHeaderProps {
  editing: boolean;
  setEditing: (editing: boolean) => void;
  onPublish: () => void;
}

const DealerEditHeader: React.FC<DealerEditHeaderProps> = ({
  editing,
  setEditing,
  onPublish,
}) => {
  const { user } = useAuth();

  return (
    <div
      className={clsx('flex items-center justify-between px-l py-m', {
        'bg-neutral-200': !editing,
        'sticky top-0 z-20 bg-red-medium': editing,
      })}
    >
      {/* Left side */}
      <div className="flex items-center gap-s">
        <div className="flex items-center gap-xs">
          {!editing ? (
            <EyeIcon className="size-[20px] fill-brandMidnight" />
          ) : (
            <ExclamationCircleIcon className="size-[20px] fill-red-light" />
          )}
          <div
            className={clsx('text-microMedium', {
              'text-brandMidnight': !editing,
              'text-white': editing,
            })}
          >
            {!editing ? 'VIEW MODE' : 'EDIT MODE'}
          </div>
        </div>
        <div className="w-px self-stretch rounded-xsmall bg-neutral-400" />
        <div
          className={clsx('text-microNormal', {
            'text-neutral-800': !editing,
            'text-white': editing,
          })}
        >
          {user?.email}
        </div>
      </div>

      {/* Right side */}
      <div className="flex items-center gap-l">
        {!editing ? (
          <Button
            variant={ButtonVariants.Secondary}
            aria-label="Enter edit mode"
            size="small"
            icon={{
              icon: <PencilSquareIcon className="size-[20px]" />,
              position: 'left',
            }}
            background="bg-white"
            onClick={() => setEditing(true)}
          >
            Edit Page Content
          </Button>
        ) : (
          <>
            <Button
              aria-label="Publish"
              variant={ButtonVariants.Secondary}
              size="small"
              icon={{
                icon: <RocketLaunchIcon className="size-[20px]" />,
                position: 'left',
              }}
              background="bg-white"
              onClick={onPublish}
            >
              Publish Changes
            </Button>
            <Button
              aria-label="Exit edit mode"
              variant={ButtonVariants.Secondary}
              size="small"
              icon={{
                icon: <ArrowRightEndOnRectangleIcon className="size-[20px]" />,
              }}
              theme="dark"
              onClick={() => setEditing(false)}
            >
              Exit
            </Button>
            <Link
              href="mailto:hi@ev.com"
              className="text-body2Medium text-white"
            >
              Help
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default DealerEditHeader;
